<form id="statusMenu" [formGroup]="filterState">
  <div id="clearStatusButtonContainer">
    <button mat-button
            id="clearStatusButton"
            (click)="handleReset()">
      <mat-icon svgIcon="tune" inline></mat-icon>
      Clear
    </button>
  </div>

  <div class="statusMenuContainer">
    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.BUSINESS_STATUS_LIST))"
                             multiple>
      <mat-button-toggle class="statusToggleButton"
                         [value]="BusinessStatusListEnum.CLOSED_PERMANENTLY">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationBusinessStatusColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Permanently closed</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="BusinessStatusListEnum.CLOSED_TEMPORARILY">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationBusinessStatusColoring colorCircleIcon"
                    svgIcon="fiber_manual_record_outline">
          </mat-icon>
          <p>Temporarily closed</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="BusinessStatusListEnum.OPEN">
        <p>Open</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             multiple
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.MANAGEMENT_STATUS_LIST))">
      <mat-button-toggle class="statusToggleButton"
                         [value]="ManagementStatusListEnum.NOT_MANAGED">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationNotManagedColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Not managed</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="ManagementStatusListEnum.MANUALLY_MANAGED">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationNotManagedColoring colorCircleIcon"
                    svgIcon="fiber_manual_record_outline">
          </mat-icon>
          <p>Manually managed</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="ManagementStatusListEnum.AUTOMATICALLY_MANAGED">
        <p>Automatically managed</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.IS_FOUND_IN_MY_BUSINESS))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.IS_FOUND_IN_MY_BUSINESS)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.IS_FOUND_IN_MY_BUSINESS)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationMissingColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Missing</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <p>Found</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.IS_DIFFERENT_IN_MY_BUSINESS))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.IS_DIFFERENT_IN_MY_BUSINESS)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.IS_DIFFERENT_IN_MY_BUSINESS)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationDifferencesColoring colorCircleIcon"
                    svgIcon="fiber_manual_record_outline">
          </mat-icon>
          <p>Open differences</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>No open differences</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.HAS_IGNORED_DIFFERENCES))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.HAS_IGNORED_DIFFERENCES)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.HAS_IGNORED_DIFFERENCES)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationDifferencesColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Accepted differences</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>No accepted differences</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.HAS_BLACKLISTED_FIELDS))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.HAS_BLACKLISTED_FIELDS)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.HAS_BLACKLISTED_FIELDS)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationBlacklistedFieldsColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Blacklisted fields</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>No blacklisted fields</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.IS_VERIFIED))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.IS_VERIFIED)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.IS_VERIFIED)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationNotValidatedColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Not validated</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <p>Validated</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.HAS_UPDATE_ERROR))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.HAS_UPDATE_ERROR)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.HAS_UPDATE_ERROR)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationUpdateErrorColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Update error</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>No update error</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.HAS_IMPORT_ERROR))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.HAS_IMPORT_ERROR)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.HAS_IMPORT_ERROR)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationImportErrorColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
          </mat-icon>
          <p>Import error</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>No import error</p>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="statusToggleGroup"
                             [formControl]="castAsFormControl(filterState.get(StatusFilterEnum.HAS_COMPLETED_CC))"
                             (click)="resetSingleToggleGrp(StatusFilterEnum.HAS_COMPLETED_CC)"
                             (change)="onSingleToggleGrpChange(StatusFilterEnum.HAS_COMPLETED_CC)">
      <mat-button-toggle class="statusToggleButton"
                         [value]="true">
        <div class="buttonWithColorCircle">
          <mat-icon class="locationHasCompletedCcColoring colorCircleIcon"
                    svgIcon="fiber_manual_record">
            fiber_manual_record
          </mat-icon>
          <p>Completed C&C</p>
        </div>
      </mat-button-toggle>
      <mat-button-toggle class="statusToggleButton"
                         [value]="false">
        <p>Not completed C&C</p>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</form>


